import React from 'react';
import { CannedQuestionsProvider } from '@/contexts/canned-questions-context';
import { CHAT_ROUTES } from '@/navigators/routes';
import { ChatDetailsScreen } from '@/screens/chats/chat-details-screen';
import { ChatStackParams } from '@/navigators/types';
import { createStackNavigator } from '@react-navigation/stack';
import { useAuthenticatedUserContext } from '@/contexts/user-context';
import { useDefaultAppTabScreenOptions } from '@/hooks/use-default-app-tab-screen-options';

const Stack = createStackNavigator<ChatStackParams>();

export const ChatStack: React.FC = () => {
  const screenOptions = useDefaultAppTabScreenOptions();
  const { selectedRestaurantRelationship } = useAuthenticatedUserContext();

  const chatUUID = selectedRestaurantRelationship.chatUUIDs[0];
  return (
    <CannedQuestionsProvider>
      <Stack.Navigator key={chatUUID} screenOptions={screenOptions}>
        <Stack.Screen
          component={ChatDetailsScreen}
          initialParams={{
            chatUUID,
          }}
          name={CHAT_ROUTES.Base}
        />
      </Stack.Navigator>
    </CannedQuestionsProvider>
  );
};
